// Components==============
import ArrowButtons from 'components/UI/ArrowButtons/ArrowButtons';
import Avatar from 'components/UI/Avatar/Avatar';
import Modal from 'components/UI/Modal/Modal';
import ProcessInfo from 'components/UI/ProcessInfo/ProcessInfo';
import ProjectProcess from 'components/UI/ProjectProcess/ProjectProcess';
import Tooltip from 'components/UI/Tooltip/Tooltip';
import { AnimatePresence } from 'framer-motion';
import { useProcessGroups } from 'hooks/useProcessGroups';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext, useRef, useState } from 'react';
import { ProjectCardContext } from '../../ProjectCard';
import './ProjectModal.module.scss';
// =========================

export default function ProjectModal() {
  const { theme, projectModalRef, setThemeModalIsOpen } = useContext(
    ProjectCardContext
  );

  const translate = useTranslate();
  const scrollRef = useRef(null);

  const [activeProject, setActiveProject] = useState(theme?.project);

  const { processGroups } = useProcessGroups(activeProject);

  return (
    <div styleName="outer-wrapper">
      <AnimatePresence>
        <Modal
          disablePositioning
          setModalIsOpen={setThemeModalIsOpen}
          externalRef={projectModalRef}
          noPadding
          noCross
        >
          <div styleName="info">
            {theme?.allProjects?.length ? (
              <h1>
                {theme?.allProjects.length === 1 &&
                  `1 ${translate('project.terms.process')}`}
                {theme?.allProjects.length > 1 &&
                  `${theme?.allProjects.length} ${translate(
                    'project.terms.processes'
                  )}`}
              </h1>
            ) : null}
            {theme?.allProjects?.map((p, i) => (
              <Tooltip
                position="top"
                content={
                  <p>
                    {p.author?.first_name} {p.author?.last_name}
                  </p>
                }
                key={i}
              >
                <button
                  type="button"
                  onClick={() => setActiveProject(p)}
                  styleName={activeProject?.id !== p.id ? 'inactive' : ''}
                >
                  <Avatar user={p.author} />
                </button>
              </Tooltip>
            ))}
          </div>

          <div styleName="process-info">
            <ProcessInfo
              processGroups={processGroups}
              user={
                activeProject?.members.find((m) => m.membership === 'owner')
                  ?.user
              }
            />
            <ArrowButtons reference={scrollRef} />
          </div>
          <div styleName="process-wrapper">
            <ProjectProcess
              project={activeProject}
              processGroups={processGroups}
              inModal
              reference={scrollRef}
            />
          </div>
        </Modal>
      </AnimatePresence>
    </div>
  );
}
